import React, { useState, useEffect } from "react";

function ClientReviewSridharParepalli() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const reviews = [
    {
      name: "- samhitha tarra",
      location: "New York, NY",
      contentHeading: "Thoughtful and Seamless ",
      content:
        "Can’t say enough good things about Sridhar, as a first time home buyer he was very helpful in getting me the best rate and making the process very seamless from start to finish. Would highly recommend him to anyone looking for a lender to guide them through the process and get the job done in a timely manner!",
    },
    {
      name: "- imran ",
      location: "Raleigh, NC",
      contentHeading:
        "Seamless, Transparent, and Hassle-Free Experience with Sridhar! ",
      content:
        "I had a fantastic experience working with Sridhar. The entire process was transparent from start to finish, with quick responses to any questions I had. Once he took over the lending process, everything was hassle-free, making it smooth and stress-free. I highly recommend Sridhar to anyone looking for a seamless loan lending experience!",
    },
    {
      name: "- Mahi ",
      location: "Sterling, VA",
      contentHeading: "Exceptional Loan Officer Service ",
      content:
        "I recently worked with Sridhar at Prime Home Loans for my home purchase in Aldie, Chantilly, Virginia, and I couldn’t be more satisfied with his service. Sridhar provided clear, timely communication and expert guidance throughout the entire loan process. His professionalism and attention to detail made the process smooth and stress-free. Sridhar went above and beyond to ensure I received the best possible loan terms and was always available to answer questions. I highly recommend his services to anyone in need of a reliable and knowledgeable loan officer. Thank you, Sridhar, for your outstanding support!",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [reviews.length]);

  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % reviews.length);
  };

  const handlePrev = () => {
    setCurrentIndex((currentIndex - 1 + reviews.length) % reviews.length);
  };

  return (
    <div className="OurSatisfiedBoxParent">
      <div className="OurSatisfiedBox">
        {reviews.map((review, index) => (
          <div
            className={`OurSatisfiedContentBox ${
              index === currentIndex ? "active" : "inactive"
            }`}
            key={index}
          >
            <span className="OurSatisfiedStars">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
            </span>
            <span className="OurSatisfiedContent">
              <span className="OurSatisfiedName">{review.contentHeading}</span>
              {review.content}
            </span>
            <span className="OurSatisfiedNameLocation">
              <span className="OurSatisfiedName">{review.name}</span>
              <span className="OurSatisfiedLocation">{review.location}</span>
            </span>
          </div>
        ))}
      </div>
      <span className="OurSatisfiedArrows">
        <i
          className="ri-arrow-left-wide-fill OurSatisfiedLeftArrow"
          onClick={handlePrev}
        ></i>
        <i
          className="ri-arrow-right-wide-fill OurSatisfiedRightArrow"
          onClick={handleNext}
        ></i>
      </span>
    </div>
  );
}

export default ClientReviewSridharParepalli;
